import { render, staticRenderFns } from "./CupsDetails.vue?vue&type=template&id=7db2e972&scoped=true"
import script from "./CupsDetails.ts?vue&type=script&lang=ts&external"
export * from "./CupsDetails.ts?vue&type=script&lang=ts&external"
import style0 from "./CupsDetails.vue?vue&type=style&index=0&id=7db2e972&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db2e972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7db2e972')) {
      api.createRecord('7db2e972', component.options)
    } else {
      api.reload('7db2e972', component.options)
    }
    module.hot.accept("./CupsDetails.vue?vue&type=template&id=7db2e972&scoped=true", function () {
      api.rerender('7db2e972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Cups/pages/CupsDetails/CupsDetails.vue"
export default component.exports